// src/components/VersionBanner.jsx
import React, { useEffect, useState } from "react";
import {
  subscribeVersion,
  clearUpdateFlag,
  getVersionState,
} from "../versionState";
import { clearAllDashboardCaches } from "../services/cache";

function VersionBanner() {
  const [info, setInfo] = useState(() => getVersionState());

  useEffect(() => {
    const unsubscribe = subscribeVersion(setInfo);
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  if (!info.updateAvailable) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-300 text-amber-900 text-xs sm:text-sm px-3 sm:px-4 py-2 flex items-center justify-between z-40">
      <span className="truncate">
        A new version of Report360 is available. Reload to get the latest
        features and fixes.
      </span>
      <button
        type="button"
        onClick={async () => {
          clearUpdateFlag();
          await clearAllDashboardCaches();
          window.location.reload();
        }}
        className="ml-3 px-2 py-1 bg-amber-600 text-white rounded text-xs shrink-0"
      >
        Reload
      </button>
    </div>
  );
}

export default VersionBanner;
